import { addEmployee, deleteEmployee, getEmployes } from "@/api";

const initState = () => ({
  employes: [],
  search_query: null,
  page: 1,
  pageSize: 15,
  total: null
});

export default {
  namespaced: true,
  state: initState,
  getters: {
    employes: state => state.employes,
    page: state => state.page,
    pageSize: state => state.pageSize,
    total: state => state.total
  },
  mutations: {
    setEmployes: (state, value) => (state.employes = value),
    setSearchQuery: (state, value) => (state.search_query = value),
    setPage: (state, value) => (state.page = value),
    setPageSize: (state, value) => (state.pageSize = value),
    setTotal: (state, value) => (state.total = value),

    reset: state => {
      const initialState = initState();
      Object.keys(initialState).forEach(key => (state[key] = initialState[key]));
    }
  },
  actions: {
    async getEmployes({ commit, state: { page, pageSize } }) {
      const res = await getEmployes({ page, pageSize });
      if (res) {
        commit("setEmployes", res.list);
        commit("setTotal", res.total);
      }
      return res;
    },

    async addEmployee({ dispatch }, data) {
      const res = await addEmployee(data);
      if (res) {
        // возвращаем промис для сброса формы в компоненте после добавления сотрудника
        return dispatch("getEmployes");
      }
      return res;
    },

    async deleteEmployee({ dispatch }, id) {
      const res = await deleteEmployee(id);
      if (res) {
        return dispatch("getEmployes");
      }
      return res;
    }
  }
};
